

export default {
    data() {
        return {
            sysName:'云速通电商物流TMS',
            isCollapse: false,
            headMenuItems:[],
            subMenuItems:[],
            sysUserName:'',
        }
    },
    mounted: function () {
        var me = this;
        
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            me.sysUserName = user.LoginName;
            
            var routerPath ="";

            user.ViewModules.forEach(element => {
                if(element.Description == '业务信息' || element.Description == '业务管理'){
                    element.className = "fa fa-fw fa-table";
                  }
                  else if(element.Description == '后台管理'){
                   element.className = "fa fa-fw fa-cog";
                 }
                 else if(element.Description == '统计分析'){
                   element.className = "fa fa-fw fa-area-chart";
                 }
                 else if(element.Description == '新增记录'){
                    element.className = "fa fa-fw fa-file-text-o";
                }
                else if(element.Description == '业务查询'){
                    element.className = "fa fa-fw fa-search";
                }
                else if(element.Description == '客户管理'){
                    element.className = "fa fa-fw fa-heart-o";
                }
                else if(element.Description == '承运商管理'){
                    element.className = "fa fa-fw fa-truck";
                }
                else if(element.Description == '用户管理'){
                    element.className = "fa fa-fw fa-user";
                }
                else if(element.Description == '修改密码'){
                    element.className = "fa fa-fw fa-lock";
                }
                else if(element.Description == '汇总'){
                    element.className = "fa fa-fw fa-bar-chart";
                }
                 else
                 {
                   element.className = "fa fa-fw fa-th";
                 }


               if(element.ParentPath == null || element.ParentPath == '' ||element.ParentPath == 'undefined')
               {
                
                   me.headMenuItems.push(element);
               } 
               else
               {
                   me.subMenuItems.push(element);
                   if(element.Name == 'MaintainTransLog'){
                    routerPath = '/MaintainTransLog';
                   }
                   else if(element.Name == 'MaintainTransLog_Sales'){
                    routerPath = '/MaintainTransLog_Sales';
                   }
                   else if(element.Name == 'TransLog'){
                    routerPath = '/TransLog';
                    }

               }
            });

            if(routerPath!=''){
                this.$router.push({ path: routerPath });
            }
        }
        
     },
    methods:{
        toggleCollapse(){
            console.log('toggleCollapse');
            console.log(this.isCollapse);
            this.isCollapse=!this.isCollapse;
        },

        logout(){
            this.$router.push({ path: '/Login' });
        },

        
    }
        
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.js